export default {
  items: [
    "Acehnese",
    "Acholi",
    "Afrikaans",
    "Akan",
    "Albanian",
    "Amharic",
    "Anuak",
    "Arabic",
    "Armenian",
    "Assamese",
    "Assyrian Neo-Aramaic",
    "Auslan",
    "Australian Indigenous Languages, nfd",
    "Azeri",
    "Badimaya",
    "Balinese",
    "Balochi",
    "Banyjima",
    "Bardi",
    "Bari",
    "Belorussian",
    "Bemba",
    "Bengali",
    "Bisaya",
    "Bislama",
    "Bosnian",
    "Bulgarian",
    "Bunuba",
    "Burmese",
    "Cantonese",
    "Catalan",
    "Cebuano",
    "Chin Haka",
    "Creole, nfd",
    "Croatian",
    "Czech",
    "Dan (Gio-Dan)",
    "Danish",
    "Dari",
    "Dhivehi",
    "Dinka",
    "Dutch",
    "English",
    "Estonian",
    "Ewe",
    "Fijian",
    "Filipino",
    "Finnish",
    "French",
    "French Creole, nfd",
    "Fulfulde",
    "Ga",
    "Gaelic (Scotland)",
    "German",
    "Gilbertese",
    "Gooniyandi",
    "Greek",
    "Gujarati",
    "Hakka",
    "Harari",
    "Hausa",
    "Hazaraghi",
    "Hebrew",
    "Hindi",
    "Hungarian",
    "Iban",
    "Icelandic",
    "Igbo",
    "Ilokano",
    "Ilonggo (Hiligaynon)",
    "Indonesian",
    "Irish",
    "Italian",
    "Japanese",
    "Jaru",
    "Kannada",
    "Karajarri",
    "Karen",
    "Kariyarra",
    "Khmer",
    "Kija",
    "Kikuyu",
    "Kinyarwanda (Rwanda)",
    "Kirundi",
    "Kirundi (Rundi)",
    "Konkani",
    "Korean",
    "Krio",
    "Kriol",
    "Kukatja",
    "Kurdish",
    "Lao",
    "Latin",
    "Latvian",
    "Lingala",
    "Lithuanian",
    "Loma (Lorma)",
    "Luganda",
    "Luo",
    "Macedonian",
    "Madi",
    "Malay",
    "Malayalam",
    "Maltese",
    "Mandarin",
    "Mandinka",
    "Mangala",
    "Manyjilyjarra",
    "Maori (Cook Island)",
    "Maori (New Zealand)",
    "Marathi",
    "Marra",
    "Martu Wangka",
    "Mauritian Creole",
    "Min Nan",
    "Miriwoong",
    "Mon",
    "Mongolian",
    "Moro (Nuba Moro)",
    "Motu (HiriMotu)",
    "Ndebele",
    "Nepali",
    "Ngaanyatjarra",
    "Ngarinyin",
    "Ngarluma",
    "Ngatjumaya",
    "Niue",
    "Norwegian",
    "Nuer",
    "Nyamal",
    "Nyangumarta",
    "Nyanja (Chichewa)",
    "Nyikina",
    "Nyungar",
    "Oriya",
    "Oromo",
    "Other Southern Asian Languages",
    "Pampangan",
    "Pashto",
    "Persian (excluding Dari)",
    "Pintupi",
    "Pitjantjatjara",
    "Polish",
    "Portuguese",
    "Punjabi",
    "Romanian",
    "Russian",
    "Samoan",
    "Serbian",
    "Serbo-Croatian/Yugoslavian, so described",
    "Shona",
    "Sindhi",
    "Sinhalese",
    "Slovak",
    "Slovene",
    "Somali",
    "Spanish",
    "Swahili",
    "Swedish",
    "Tagalog",
    "Tamil",
    "Telugu",
    "Tetum",
    "Thai",
    "Tibetan",
    "Tigre",
    "Tigrinya",
    "Tjupany",
    "Tok Pisin (Neomelanesian)",
    "Tokelauan",
    "Tongan",
    "Tswana",
    "Tulu",
    "Turkish",
    "Turkmen",
    "Ukrainian",
    "Urdu",
    "Uygur",
    "Uzbek",
    "Vietnamese",
    "Wajarri",
    "Walmajarri",
    "Wangkatha",
    "Warlpiri",
    "Welsh",
    "Wiradjuri",
    "Wu",
    "Xhosa",
    "Yawuru",
    "Yindjibarndi",
    "Yoruba",
    "Yulparija",
    "Yumplatok (Torres Strait Creole)",
    "Zulu"
  ]
}



// WEBPACK FOOTER //
// ../data/wa/language.js